import { render } from "./Animate.vue?vue&type=template&id=9f950b66&scoped=true"
import script from "./Animate.vue?vue&type=script&lang=ts"
export * from "./Animate.vue?vue&type=script&lang=ts"

import "./Animate.vue?vue&type=style&index=0&id=9f950b66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9f950b66"

export default script